"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  .as-label {
    margin: 0 6px;
  }
`;
const AliasSelector = ({ entity, value, onChange }) => {
    return (react_1.default.createElement(StyledDiv, { className: 'alias-selector-container' },
        react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'as-label' }, "as"),
        react_1.default.createElement(QueryFieldSelector_1.default, { className: 'alias-selector', placeholder: 'Alias', value: value || (0, lodash_1.camelCase)(entity.name), options: [(0, lodash_1.camelCase)(entity.name)], onChange: value => {
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            }, onAdd: value => {
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            } })));
};
exports.default = AliasSelector;
//# sourceMappingURL=AliasSelector.js.map